export class lsFieldBase extends HTMLButtonElement {
  constructor() {
    super(); // Call the constructor of the parent class
  }

  // Add custom methods and properties here
}

//customElements.define('lsFieldBase', lsFieldBase, { extends: 'div' });
